export const ProductType = 'RPDPLACEHOLDER';

export enum ProductPermissions {
  PLACEHOLDER = 'PLACEHOLDER',
}
export const ACCEPTED_FILE_TYPES = [
  'image/png',
  'image/jpeg',
  'application/pdf',
];
export const SIZE_UNIT_KB = 'KB';
export const SIZE_UNIT_MB = 'MB';
export const SIZE_UNIT_GB = 'GB';
export const APPLICATION_PDF = 'application/pdf';

// IdentityTab constants
export const IDENTITY_DOC_SIDE = { FRONT: 'F', BACK: 'B' } as const;

export const IDENTITY_TAB_STEPS = [
  { label: 'Identity', isActive: true, isCompleted: false },
  { label: 'Code Confirmation', isActive: false, isCompleted: false },
  { label: 'Residence', isActive: false, isCompleted: false },
  { label: 'Income', isActive: false, isCompleted: false },
];

export const IDENTITY_MIN_DATE = new Date('1900-01-01');

export const RESIDENCE_TAB_DOCUMENT_LIST = [
  {
    type: 'P',
    value: 'Utility bill (Electricity, Gas, Garbage, Water, or Sewer)',
  },
  {
    type: 'P',
    value: 'Current/paid property tax',
  },
  // {
  //   type: 'P',
  //   value: 'Cable TV or Internet bill',
  // },
  // {
  //   type: 'P',
  //   value: 'Government Letters',
  // },
  // {
  //   type: 'S',
  //   value: 'Bank Statement',
  // },
  // {
  //   type: 'S',
  //   value: 'Property tax bill',
  // },
  // {
  //   type: 'S',
  //   value: 'Mortgage statement',
  // },
  // {
  //   type: 'S',
  //   value: 'Insurance Documents',
  // },
  // {
  //   type: 'S',
  //   value: 'School Records',
  // },
  // {
  //   type: 'S',
  //   value: 'Tax Documents',
  // },
];

export const INCOME_TAB_DOCUMENT_LIST = [
  {
    type: 'P',
    value: 'Payroll Receipt',
  },
  {
    type: 'P',
    value: 'Employee Certificate',
  },
  {
    type: 'P',
    value: 'Account Statement',
  },
  {
    type: 'S',
    value: 'Purchase Receipts',
  },
  {
    type: 'S',
    value: 'Bank Transfer',
  },
  {
    type: 'S',
    value: 'Pension Statement',
  },
  {
    type: 'S',
    value: 'Other (Remittances, partner’s income, etc.)',
  },
  // {
  //   type: 'S',
  //   value: 'Full-Time Job',
  // },
  // {
  //   type: 'S',
  //   value: 'Part-Time Job',
  // },
  // {
  //   type: 'S',
  //   value: 'Self-Employment',
  // },
  // {
  //   type: 'S',
  //   value: 'Social Security',
  // },
  // {
  //   type: 'S',
  //   value: 'Alimony',
  // },
  // {
  //   type: 'S',
  //   value: 'Unemployment Benefits',
  // },
  // {
  //   type: 'S',
  //   value: 'Other',
  // },
];
